<script lang="ts">
	import Katex from './Katex.svelte';
	import uqnSplit from './functions/uqnSplit';
	import Complex from './functions/complexClass';
	import polyBuilder from './functions/polyBuilder';
	import polyExpand from './functions/polyExpand';
	//import brackets from './functions/brackets';
	//import fractionBuilder from './functions/fractionBuilder';

	export let uqn: number;

	let t: number;
	let qn: string, root1: string;
	$: t = Number(uqn.toString()[0]);
	$: [qn,root1] = uqnToQn(uqn,t);

	function uqnToQn(u:number,t:number):string[]{
		if (t==1 || t==2){ // cubic
			return type12Generator(u);
		} else if (t<5){ // quartic
			return type34Generator(u);
		} else if (t==5 || t==6){ //  
			return type5Generator(u);
		//} else if (t==6){ 
		//	return type6Generator(u);
		//} else{
		//	return type5Generator(u);
		}
	}

	function type12Generator(u:number):string[]{
		let [t, x, y, r, sign] = uqnSplit(u);
		let a = 1;
		if (sign>3){
			a = 2; r = r*2-1;
		}
		const xrSign = sign%4;
		if (xrSign%2==1){
			r *= -1;
		}
		if (xrSign>1){
			x *= -1;
		}
		if (Math.random()<0.5){
			y *= -1;
		}
		const root1 = new Complex(x,y);
		const root2 = new Complex(x,-y);
		let eqn = polyExpand(polyExpand([1,root1.multiply(-1)],[1,root2.multiply(-1)]),[a,-r]) as (number|string)[];
		if (t==2){
			eqn[1] = "b"; eqn[2] = "c";
		}
		return [polyBuilder(eqn,"z",eqn.length-1,false)+"=0",root1.toString()];
	}	

	function type34Generator(u:number):string[]{
		let [t, x1, y1, x2, y2, sign] = uqnSplit(u);
		const xrSign = sign%4;
		if (xrSign%2==1){
			x2 *= -1;
		}
		if (xrSign>1){
			x1 *= -1;
		}
		if (sign > 3){
			y2 *= -1;
		}
		if (Math.random()<0.5){
			y1 *= -1;
		}
		const root1 = new Complex(x1,y1);
		const root2 = new Complex(x1,-y1);
		let root3: Complex, root4: Complex;
		if (t==3){
			root3 = new Complex(x2,y2);
			root4 = new Complex(x2,-y2);
		} else{
			root3 = new Complex(x2,0);
			root4 = new Complex(y2,0);
		}
		let eqn = polyExpand(polyExpand([1,root1.multiply(-1)],[1,root2.multiply(-1)]),polyExpand([1,root3.multiply(-1)],[1,root4.multiply(-1)])) as (number)[];
		return [polyBuilder(eqn,"z",eqn.length-1,false)+"=0",root1.toString()];
	}	

	function type5Generator(u:number):string[]{
		let [t, x1, y1, x2, y2, sign] = uqnSplit(u);
		switch (sign){
			case 1:
				y2 *= -1;
				break
			case 2:
				x2 *= -1;
				break
			case 3:
				y1 *= -1;
				break
			case 4:
				x1 *= -1;
				break
			case 5:
				y2 *= -1; y1 *= -1;
				break
			case 6:
				y1 *= -1; x2 *= -1;
				break
			case 7:
				x2 *= -1; x1 *= -1;
				break
			case 8:
				x1 *= -1; y2 *= -1;
				break
			case 9:
				y2 *= -1; x2 *= -1; y1 *= -1;
				break
		}
		const root1 = new Complex(x1,y1);
		const root2 = new Complex(x2,y2);
		let eqn = polyExpand([1,root1.multiply(-1)],[1,root2.multiply(-1)],false) as (number|Complex)[];
		if (t==6){
			eqn = polyExpand([new Complex(0,1)],eqn,false);
		}
		let eqnString = eqn as (number|Complex|string)[];
		eqnString[1] = "("+eqn[1].toString()+")";
		return [polyBuilder(eqn,"z",eqn.length-1,false)+"=0",root1.toString()];
	}	
</script>

<p> 
	An equation is given by
	<Katex math={qn}/>
</p>
{#if t==1}
<p>
	(a) Verify that <Katex math={"z="+root1}/> is a root of the equation.
</p>
<p>
	(b) Hence solve the equation.
</p>
{:else if t==2}
<p>It is given that <Katex math={"z="+root1}/> is a root of the equation.</p>
<p>
	Find, in either order, the values of the real constants <Katex math="b"/> and <Katex math="c"/>,
	and all the roots of the equation.
</p>
{:else if t<7}
<p>It is given that <Katex math={"z="+root1}/> is a root of the equation.</p>
<p>
	Solve the equation.
</p>
{/if}